module.exports = __webpack_public_path__ + "img/arborcare_logo.ebf2d950.png";